import React, { useState } from "react";
import { useMfProps } from "@crystal/core";
import { consentsConfig } from "../../config/config.js";
import { PermissionToDocumentMap } from "../../types/index.js";
import { SelectAllConsents } from "../select-all-consents.js";
import ExplicitConsent from "./explicit-consent.js";
import ExplicitConsentWithPermission from "./explicit-consent-with-permission.js";
const PermissionTypes = [
  PermissionToDocumentMap.NEWSLETTER,
  PermissionToDocumentMap.MARKETING_SMS,
  PermissionToDocumentMap.PAID_MEDIA,
  PermissionToDocumentMap.DATA_PROCESSING
];
const findPermission = (doc, permissions) => {
  var _a;
  return (_a = PermissionTypes.map(
    (type) => doc.document.documentType.includes(type) ? permissions.find((p) => p.permissionType.includes(type)) : void 0
  ).filter(Boolean)) == null ? void 0 : _a[0];
};
const ExplicitConsents = ({ documents, onChange, permissions, scenarioType }) => {
  if (!documents.length) {
    return null;
  }
  const [checked, setChecked] = useState([]);
  const isSelectAllEnabled = getIsSelectAllEnabled(scenarioType);
  const showSelectAllConsents = isSelectAllEnabled && !permissions.length;
  const requiredDocuments = documents.filter((doc) => doc.configuration.acceptanceRequired);
  const isSelectAllChecked = checked.length === requiredDocuments.length;
  const handleSelectAllCheckbox = (e) => {
    if (e.target.checked) {
      const documentTypes = requiredDocuments.map((item) => item.document.documentType);
      setChecked(documentTypes);
    } else {
      setChecked([]);
    }
  };
  const handleExplicitDocument = (update) => {
    const {
      configuration: { accepted, acceptanceRequired },
      document: { documentType }
    } = update;
    if (!accepted) {
      const data = checked.filter((item) => item !== documentType);
      setChecked(data);
    } else {
      if (acceptanceRequired) {
        setChecked([...checked, documentType]);
      }
    }
    onChange(update);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "gl-vspace-bpall-small", "data-auto-id": "explicit-consents" }, showSelectAllConsents && /* @__PURE__ */ React.createElement(SelectAllConsents, { id: "select-all-consents", isChecked: isSelectAllChecked, onChange: handleSelectAllCheckbox }), documents.filter((d) => !d.configuration.hidden).map((doc, index) => {
    var _a, _b, _c;
    const permission = findPermission(doc, permissions);
    if (permission) {
      return /* @__PURE__ */ React.createElement(
        ExplicitConsentWithPermission,
        {
          key: `doc-${index}`,
          document: doc,
          onChange,
          permission
        }
      );
    } else if (!isSelectAllEnabled) {
      return /* @__PURE__ */ React.createElement(
        ExplicitConsent,
        {
          key: `doc-${index}`,
          document: doc,
          isChecked: ((_a = doc == null ? void 0 : doc.configuration) == null ? void 0 : _a.accepted) ?? ((_b = doc == null ? void 0 : doc.configuration) == null ? void 0 : _b.acceptancePreSelected),
          onChange,
          scenarioType
        }
      );
    } else if (isSelectAllEnabled) {
      return /* @__PURE__ */ React.createElement(
        ExplicitConsent,
        {
          key: `doc-${index}`,
          document: doc,
          isChecked: checked.includes((_c = doc == null ? void 0 : doc.document) == null ? void 0 : _c.documentType),
          onChange: handleExplicitDocument,
          scenarioType,
          indentCheckbox: Number(index) < requiredDocuments.length,
          isSelectAllEnabled: true,
          isSelectAllChecked
        }
      );
    }
  }));
};
const getIsSelectAllEnabled = (scenarioType) => {
  const { isSelectAllEnabled, selectAllScenarios } = consentsConfig.evaluateWithContext(useMfProps().context);
  return isSelectAllEnabled && selectAllScenarios.includes(scenarioType);
};
export {
  ExplicitConsents as default
};
//# sourceMappingURL=explicit-consents.js.map
